import {
  DatagridConfigurable,
  List,
  TextField,
  TopToolbar,
  SelectColumnsButton,
  Pagination,
  CreateButton,
  SearchInput,
  EmailField,
  ArrayField,
  SingleFieldList,
  ChipField,
  FunctionField,
  SelectInput,
  required,
} from "react-admin";

import { CLIENT_SEARCH_SOURCE, FILTER_LIMITS } from "@/constants/filters";
import { ArrayOfStrings } from "@/fields/ArrayOfStrings";

import { ACTIVE_FILTER_OPTIONS } from "./constants";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <CreateButton />
  </TopToolbar>
);

const DEFAULT_FILTERS = {
  active: true,
};

export const UsersList = () => (
  <List
    actions={<ListActions />}
    filters={[
      <SearchInput key="search" source={CLIENT_SEARCH_SOURCE} alwaysOn />,
      <SelectInput
        key="active"
        source="active"
        choices={ACTIVE_FILTER_OPTIONS}
        validate={required()}
        alwaysOn
      />,
    ]}
    perPage={FILTER_LIMITS[0]}
    pagination={<Pagination rowsPerPageOptions={FILTER_LIMITS} />}
    storeKey={false}
    filterDefaultValues={DEFAULT_FILTERS}
  >
    <DatagridConfigurable bulkActionButtons={false}>
      <TextField source="id" sortable={false} />
      <TextField source="username" sortable={false} />
      <EmailField source="email" sortable={false} />
      <ArrayField source="groups" sortable={false}>
        <SingleFieldList linkType={false}>
          <ChipField source="name" />
        </SingleFieldList>
      </ArrayField>
      <ArrayOfStrings source="roles" sortable={false} />
      <FunctionField
        label="Активен"
        render={(record: { active?: boolean }) =>
          record.active ? "Да" : "Нет"
        }
      />
    </DatagridConfigurable>
  </List>
);
